import { Reveal, Eyebrow } from "../components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Science advances through connection",
    text: "Moving promising science forward takes more than scientific expertise — it takes development strategy, clinical insight, regulatory understanding and organizational capability, connected and working as one.",
  },
  {
    num: "02",
    title: "The right expertise, at the right decision",
    text: "The hardest decisions in life sciences are made between the milestones. Connecting the right people and judgment at exactly those moments is what changes a program's trajectory.",
  },
  {
    num: "03",
    title: "Judgment compounds",
    text: "Senior perspective applied early — when the cost of being wrong is still low — is the highest-leverage investment a life sciences organization can make.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="bg-[#F8F9FA] py-24 lg:py-36">
    <div className="max-w-3xl mx-auto px-6 sm:px-10">
      <Reveal>
        <Eyebrow>Manifesto</Eyebrow>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12] text-[#0A0F1D] mt-6">
          The Calliope <em className="italic text-teal-700">manifesto.</em>
        </h2>
      </Reveal>
      <div className="mt-12 space-y-0 divide-y divide-slate-200 border-y border-slate-200" data-testid="manifesto-chapters">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.1}>
            <div className="py-8 grid grid-cols-[auto_1fr] gap-6 group">
              <span className="font-serif text-3xl text-teal-700/60 group-hover:text-teal-700 transition-colors duration-300">
                {c.num}
              </span>
              <div>
                <h3 className="font-serif text-xl sm:text-2xl text-[#0B132B] leading-snug">{c.title}</h3>
                <p className="mt-3 text-sm sm:text-[15px] text-slate-600 leading-relaxed">{c.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
